/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Store } from '@ngrx/store';
import { FeatureFlagService } from '@shared/services/feature-flag.service';
import { authenticationQuery } from '@shared/state/selectors/authentication/authentication.selectors';
import { appQuery } from '@shared/state/selectors/app/app.selectors';
import { combineLatest, filter, first, switchMap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProductFruitsInitService {
  private _hasInitialised = false;

  constructor(
    private _store: Store,
    private _featureFlagService: FeatureFlagService
  ) {
    this._store
      .select(authenticationQuery.getIsLoggedIn)
      .pipe(
        filter(isLoggedIn => isLoggedIn),
        switchMap(() =>
          combineLatest([
            this._store.select(authenticationQuery.getUser).pipe(first()),
            this._store.select(appQuery.getListing).pipe(
              filter(listing => !!listing),
              first()
            ),
            this._featureFlagService.getFlagsLoaded().pipe(
              filter(loaded => loaded),
              switchMap(() => this._featureFlagService.getFeatureFlags().pipe(first()))
            )
          ])
        ),
        first()
      )
      .subscribe(([user, listing, { flags }]) => {
        if (!user || this._hasInitialised) return;

        this._hasInitialised = true;

        // Inject the Product Fruits SDK script
        (window as any).$productFruits = (window as any).$productFruits || [];
        (window as any).productFruits = (window as any).productFruits || {};
        (window as any).productFruits.scrV = '2';

        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://app.productfruits.com/static/script.js';
        document.head.appendChild(script);

        const displayName = user.displayName || '';
        const spaceIndex = displayName.indexOf(' ');

        (window as any).$productFruits.push([
          'init',
          environment.productFruitsWorkspaceCode,
          'en',
          {
            username: user.userId,
            email: user.email,
            firstname: spaceIndex > -1 ? displayName.substring(0, spaceIndex) : displayName,
            lastname: spaceIndex > -1 ? displayName.substring(spaceIndex + 1) : '',
            listing: listing.title,
            role: 'supplier',
            signUpAt: listing.dateCreated,
            props: {
              listingStatus: listing.status,
              listingUuid: listing.uuid,
              flags: flags.join(','),
              inputFlags: listing.inputFlags
            }
          }
        ]);
      });
  }
}
